module.exports = __webpack_public_path__ + "media/features/use-cases/images/image_de-6fd57063729fbb846551e869237a5fa5.png";